module.exports = __webpack_public_path__ + "img/111024.335ddf20.png";